<script lang="ts">
	import FooterContainer from '$lib/Components/Footer/FooterContainer.svelte';
	import HeaderContainer from '$lib/Components/Header/HeaderContainer.svelte';
	import LoadingBlock from '$lib/Components/LoadingBlock.svelte';
	import GtmBody from '$lib/Components/gtm-body.svelte';
	import Gtm from '$lib/Components/gtm.svelte';
	import { useAccount } from '$lib/account/account';
	import { getCurrentAccount } from '$lib/account/get-current-account';
	import { useAllSources } from '$lib/all-sources/app-sources';
	import { useAllTimezones } from '$lib/all-timezones/all-timezones';
	import { useAppBookingOptions } from '$lib/app-booking-options/app-booking-options';
	import { awsInit } from '$lib/aws/aws-init';
	import { useBookingData } from '$lib/booking-data/booking-data';
	import { useClient } from '$lib/client/client';
	import { scrollToTop } from '$lib/scroll-to-top';
	import { fade } from 'svelte/transition';
	import '../../app.css';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';

	awsInit();
	// fetch one time when system load.
	getCurrentAccount();

	onMount(() => {
		($bookingData.code = $page.url.searchParams.get('code')),
			($bookingData.utmOptions = {
				utm_source: $page.url.searchParams.get('utm_source'),
				utm_medium: $page.url.searchParams.get('utm_medium'),
				utm_campaign: $page.url.searchParams.get('utm_campaign'),
				utm_term: $page.url.searchParams.get('utm_term'),
				utm_content: $page.url.searchParams.get('utm_content')
			});
	});

	const { account } = useAccount();
	const { client } = useClient();
	const { appBookingOptions } = useAppBookingOptions();
	const { allTimezones } = useAllTimezones();
	const { allSources } = useAllSources();
	const { bookingDataLoaded } = useBookingData();
	const { bookingData } = useBookingData();

	// make sure important and global datas ready before reach any sub-components.
	$: isReady =
		// account module must be loaded
		$account !== void 0 &&
		// client module must be loaded
		$client !== void 0 &&
		// options must be requested
		!!$appBookingOptions &&
		//  load all timezones
		!!$allTimezones &&
		// load all soures
		!!$allSources &&
		// booking data must load and ready if local session available
		$bookingDataLoaded;

	let showScrollTop = false;

	const scrollTopLine = (node: HTMLElement) => {
		const ob = new IntersectionObserver(
			([entry]) => {
				showScrollTop = !entry.isIntersecting;
			},
			{
				threshold: 0,
				rootMargin: '0px'
			}
		);

		ob.observe(node);

		return {
			destroy: () => ob.disconnect()
		};
	};
</script>

<svelte:head>
	<title>Chess at Three</title>
</svelte:head>

<Gtm />

<!-- body -->
<GtmBody />

<div class="min-h-[100vh] m-auto flex flex-col">
	<div
		class="px-5 flex-1 flex flex-col max-w-screen-content mx-auto w-full min-h-[calc(100vh-230px)]"
	>
		<HeaderContainer />

		<div use:scrollTopLine />

		{#if !isReady}
			<LoadingBlock absolute class="min-h-[calc(100vh-230px)]" fullHeight />
		{:else}
			<slot />
		{/if}
	</div>

	<!-- <div class="grow flex-none" />

	<FooterContainer /> -->

	{#if showScrollTop}
		<button class="fixed z-[100] right-5 bottom-5" on:click={() => scrollToTop()} transition:fade>
			<img class="w-10 -rotate-90" src="/icons/arrow-right.svg" alt="arrow" />
		</button>
	{/if}
</div>
